<template>
  <Dualist
    :currentLocationId="currentSubsidiaryId"
    :environments="accessibleFranchisors"
    :errorLoadingLocations="errorLoadingSubsidiaries"
    :initialEnvironmentId="currentEnvironmentId"
    :isRep="true"
    :isLoadingLocations="isLoadingSubsidiaries"
    @close="onClose"
    @locations-retry="onSelectEnvironment"
    @select-environment="onSelectEnvironment"
    @select-location="onSelectLocation"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Dualist } from '@listen360/alexandria'

export default {
  name: 'OrganizationSelector',
  components: {
    Dualist
  },
  computed: {
    ...mapGetters({
      accessibleFranchisors: 'user/accessibleFranchisors',
      currentEnvironment: 'user/currentEnvironment',
      currentSubsidiary: 'user/currentSubsidiary',
      tempEnvironment: 'user/tempEnvironment'
    }),
    currentEnvironmentId() {
      return this.currentEnvironment.id
    },
    currentSubsidiaryId() {
      return this.currentSubsidiary.id
    },
    errorLoadingSubsidiaries() {
      return Boolean(this.tempEnvironment.error)
    },
    isLoadingSubsidiaries() {
      return this.tempEnvironment.isLoading
    }
  },
  methods: {
    ...mapActions({
      getAccessibleFranchisor: 'user/getAccessibleFranchisor',
      setCurrentEnvironment: 'user/setCurrentEnvironment',
      setCurrentSubsidiary: 'user/setCurrentSubsidiary',
      setTempEnvironment: 'user/setTempEnvironment'
    }),
    onClose() {
      this.$emit('close')
    },
    onSelectEnvironment(environment) {
      if (!environment.subsidiaries && !environment.isLoading) {
        this.getAccessibleFranchisor({ franchisorId: environment.id })
      }

      this.setTempEnvironment(environment)
    },
    onSelectLocation(subsidiary) {
      this.setCurrentSubsidiary(subsidiary)
      this.setCurrentEnvironment(this.tempEnvironment)
      this.onClose()
    }
  },
  watch: {
    accessibleFranchisors(curr, prev) {
      if (prev.length === 0 && curr.length === 1) {
        this.setCurrentEnvironment(curr[0])
      }
    }
  }
}
</script>
